module.exports = __webpack_public_path__ + "img/pos2_banner.bf3b8b95.png";